import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import credential from "../../API/Credentials.json";
import { apiRequest } from "../../API/apiServices";

export const fetchCountryCodeData = createAsyncThunk(
  "countryCodes/fetchCountryCodeData",
  async (_, { rejectWithValue }) => {
    try {
      const endpoint = credential?.CountryCodes_API?.end_point;
      const apiMethod = credential?.request?.post;
      const apiBody = credential?.CountryCodes_API?.body;
      const response = await apiRequest(apiMethod, endpoint, apiBody);
      if (response.error) {
        return rejectWithValue(response.error);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch data");
    }
  }
);

const CountryCodeSlice = createSlice({
  name: "countryCodes",
  initialState: {
    countries: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryCodeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountryCodeData.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload;
      })
      .addCase(fetchCountryCodeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default CountryCodeSlice.reducer;
